import { defineComponent as _defineComponent } from 'vue'
import * as validation from 'JS/components/blain-form/validation';
import BForm from 'JS/components/blain-form/BForm.vue';
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import HorizontalTextDivider from 'JS/components/HorizontalTextDivider.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { BButtonSubmitButton, BPhoneNumberField, BTextField } from "Src/js/components/blain-form";
import { IJoinRewardsStep, ILinkAccountLookupInfo, ILinkRewardsUserResponse, IVerifyUserData, RewardsReasonCode } from 'JS/types/rewards';
import { onMounted, ref } from 'vue';
import { useServices } from '../../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectRewardsForm',
  props: {
	customerEmail: {
		type: String,
		defaultValue: ""
	}
},
  emits: ["switch-page", "loading"],
  setup(__props, { emit }: { emit: ({
	(e: 'switch-page', page: IJoinRewardsStep, data?: IVerifyUserData): void,
	(e: 'loading', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const { rewardsService } = useServices();

const phoneNumber = ref<string>("");
const emailAddress = ref<string>("");
const rewardsNumber = ref<string>("");
const errorMessage = ref<string>("");
const headerFocuser = ref<HTMLElement | null>(null);

async function submitLookupRewardsData() {
	if (phoneNumber.value && emailAddress.value || phoneNumber.value && rewardsNumber.value || emailAddress.value && rewardsNumber.value) {
		errorMessage.value = "<span class='bold'>Please only enter one piece of information.</span>";
		return;
	}
	emit('loading', true);
	const lookupInfo: ILinkAccountLookupInfo = {
		phoneNumber: phoneNumber.value,
		rewardsNumber: rewardsNumber.value,
		email: emailAddress.value
	};
	const results: ILinkRewardsUserResponse = await rewardsService.findRewardsToLink(lookupInfo);

	if (!results) {
		errorMessage.value = "<span class='bold'>Something went wrong. Please try again or call Customer Service at 1-800-210-2370.</span>";
	} else {
		switch (results.reasonCode) {
			case RewardsReasonCode.CUSTOMER_HAS_REWARDS:
				emit('switch-page', 'customer-has-rewards');
				break;
			case RewardsReasonCode.VERIFICATION_REQUIRED:
				emit('switch-page', 'verification-connect', {
					phone: results.phone,
					email: results.email,
					rewardsNumber: rewardsNumber.value,
					variant: 'verification-connect',
					redactedData: results.redactedData,
				});
				break;
			case RewardsReasonCode.REWARDS_ACCOUNT_ALREADY_LINKED:
				emit('switch-page', 'account-in-use', {
					phone: results.phone,
					email: results.email,
					rewardsNumber: rewardsNumber.value,
					variant: 'account-in-use',
					redactedData: results.redactedData,
				});
				break;
			default:
				errorMessage.value = results.errorMessage;
		}
	}
	emit('loading', false);
}

onMounted(() => {
	emailAddress.value = props.customerEmail;
	headerFocuser.value?.focus();
});


return { __sfc: true,props, emit, rewardsService, phoneNumber, emailAddress, rewardsNumber, errorMessage, headerFocuser, submitLookupRewardsData, validation, BForm, ErrorBanner, HorizontalTextDivider, LinkButton, BButtonSubmitButton, BPhoneNumberField, BTextField }
}

})